import { EnumBase } from 'hay-core-react';
class RouterboardTipoEnum extends EnumBase {
    constructor() {
        super(
            ['main.routerboard.tipo.routeros'],
            'main.routerboard.tipo.routeros'
        );
    }
}

const instance = new RouterboardTipoEnum();
export default instance;
